import React, { forwardRef } from "react";
import { chakra, Input, InputGroup, InputRightElement } from "@chakra-ui/react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CalendarIcon } from "components/Icons";
import { CloseIcon } from "@chakra-ui/icons";

const CustomInput: any = forwardRef((child, ref?: React.LegacyRef<HTMLDivElement>) => {
  const childInner: any = child;
  return (
    <InputGroup
      onClick={childInner.onClick}
      ref={ref}
      maxW="250px"
      isolation="isolate"
    >
      <Input
        value={childInner.value}
        placeholder={childInner.placeholder}
        disabled={childInner.disabled}
        readOnly
      />
      <InputRightElement
        children={
          childInner.allowClear && !!childInner.value ? (
            <CloseIcon
              data-testid="close-icon"
              color="#1175B5"
              cursor="pointer"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                childInner.onClear?.();
              }}
            />
          ) : (
            <CalendarIcon />
          )
        }
      />
    </InputGroup>
  );
});

interface Props {
  minDate?: Date;
  onChange?: (date?: Date) => void;
  selected?: Date;
  placeholder?: string;
  excludeDates?: Date[];
  filterDate?: (date: Date) => boolean;
  disabled?: boolean;
  allowClear?: boolean;
}

const ChakraDatePicker = chakra(ReactDatePicker as any);

const DatePicker = ({
  onChange,
  selected,
  minDate,
  excludeDates,
  placeholder = "Click to select a date",
  filterDate,
  disabled,
  allowClear,
}: Props) => {
  return (
    <ChakraDatePicker
      onChange={onChange}
      selected={selected}
      customInput={
        <CustomInput
          allowClear={allowClear}
          onClear={() => onChange?.(undefined)}
        />
      }
      dateFormat="dd/MM/yyyy"
      placeholderText={placeholder}
      minDate={minDate}
      excludeDates={excludeDates}
      filterDate={filterDate}
      disabled={disabled}
    />
  );
};

export default DatePicker;
